import {
  Button,
  CardContent,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material';
import { getChallenge } from 'actions/challenge';
import { createTeam } from 'actions/team';
import OpenSourceForm from 'components/CreateTeamForm/openSourceForm';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './index.css';
type CreateTeamFormProps = {
  challengeId: string;
};
const CreateTeamForm = ({ challengeId }: CreateTeamFormProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [inSubmission, setInSubmission] = useState<boolean>(false);
  const [challenge, setChallenge] = useState<any>();
  const [openSource, setOpenSource] = useState<string>(
    'Yes, training code, evaluation code, and trained models.'
  );

  useEffect(() => {
    getChallenge(challengeId).then((c) => {
      setChallenge(c);
    });
  }, [challengeId]);
  const handleOpenSourceSelection = (e: any) => {
    setOpenSource(e.target.value);
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    setInSubmission(true);
    e.preventDefault();
    let data = new FormData(e.target as HTMLFormElement);
    let teamName = data.get('teamName')!.toString();

    createTeam(challengeId, teamName, { openSource })
      .then(() => {
        enqueueSnackbar('Created team successfully', {
          variant: 'success',
        });
        history.go(0);
      })
      .catch((err) => {
        if (err.response.data && err.response.data.message) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
          });
        } else {
          enqueueSnackbar(err.message, {
            variant: 'error',
          });
        }
      })
      .finally(() => {
        setInSubmission(false);
      });
  };
  if (challenge === undefined) return <></>;
  if (challenge.status === 'closed')
    return <div>The submission has closed</div>;

  return (
    <div className="CreateTeamForm">
      <Paper elevation={3} className="submit-card">
        <CardContent>
          <Typography variant="h5" style={{ fontWeight: 700 }}>
            Create Team Form
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              className="name-input"
              label="Team name (visible to everyone)"
              color="primary"
              name="teamName"
              type="text"
              required
            />
            <OpenSourceForm
              handleOpenSourceSelection={handleOpenSourceSelection}
              openSource={openSource}
            />
            <br />
            <Button
              className="submit-btn"
              type="submit"
              variant="contained"
              disabled={inSubmission}
            >
              {!inSubmission ? (
                'Create Team'
              ) : (
                <>
                  <span style={{ marginRight: '0.5rem' }}>Creating</span>
                  <CircularProgress
                    style={{ verticalAlign: 'middle' }}
                    size={20}
                  />
                </>
              )}
            </Button>
            {/* vertical-align: middle; */}
          </form>
        </CardContent>
      </Paper>
    </div>
  );
};

export default CreateTeamForm;
